"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownSectionHeader = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.DropdownSectionHeader = function (_a) {
    var className = _a.className, children = _a.children;
    return (react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "h3", className: classnames_1.default("gd-drill-to-url-section-title gd-list-item gd-list-item-header", className) },
        react_1.default.createElement("span", null, children)));
};
//# sourceMappingURL=DropdownSectionHeader.js.map